import styled from 'react-emotion'
import { color, spacer } from 'stylist'

const PlatformSectionTitle = styled.h5`
  flex-basis: 100%;
  margin-bottom: ${spacer(4)};
  color: ${color('white')};
  text-transform: uppercase;

  @supports (display: grid) {
    & {
      margin-bottom: 0;
      grid-column: 1 / -1;
    }
  }
`

export default PlatformSectionTitle



// WEBPACK FOOTER //
// ./src/routes/home/components/PlatformSectionTitle.js